module.exports = __webpack_public_path__ + "static/GloberBold-cbf7fcaab458bc832688cea3eded844a.woff";